import React from 'react'
import translations from './translations'

translations.add('en', {
    invalidCvv: 'Please enter a valid security code',
    pleaseEnter: 'Please enter:',
    backCardList: 'Back to card list'
})
